import { graphql } from 'react-apollo'

import { compose, fromRenderProps, withProps } from 'recompose'

import withHeroText from 'components/HOCs/withHeroText'
import withLiveContent, { LiveContentProps } from 'components/HOCs/WithLiveContent'
import { withApolloErrorModal } from 'utils/Apollo/apolloErrorHandlingProvider'
import { FunnelContext, FunnelContextProps } from 'utils/FunnelContext'

import PersonalInfo from '../Shared'
import { PersonalInfoProps } from '../Shared/types'
import withPersonalInfo from '../Shared/withPersonalInfo'
import rows, { handleSubmit } from './form'
import updatePersonalInfo from './mutation.gql'

type Props = PersonalInfoProps & LiveContentProps

export const enhance = compose<Props, {}>(
  fromRenderProps<Partial<FunnelContextProps>, {}, Partial<FunnelContextProps>>(
    FunnelContext.Consumer,
    ({ isBackEnabled, isDynamicFunnelEnabled, routeToPage }) => ({
      isBackEnabled,
      isDynamicFunnelEnabled,
      routeToPage,
    }),
  ),
  withLiveContent,
  withApolloErrorModal,
  withHeroText,
  graphql(updatePersonalInfo, { name: 'updatePersonalInfo' }),
  withPersonalInfo({
    handleSubmit,
    showPhoneNumber: false,
    showNames: true,
  }),
  withProps(({ data, values, liveContent, heroText }) => {
    const requiredFields = Object.values(values).filter((_, index) => index !== 4)
    return {
      rows,
      loading: data.loading,
      valid: requiredFields.every(Boolean),
      footnote: liveContent('hero_footnote'),
      footnoteLock: liveContent('hero_footnote_lock', { fallback: false, renderer: 'raw' }),
      submitCta: liveContent('submit_cta', { fallback: 'Next' }),
    }
  }),
)

export default enhance(PersonalInfo)
